module.exports = __webpack_public_path__ + "img/Wp_2032.37552448.png";